import { render, staticRenderFns } from "./expensesDataTable.vue?vue&type=template&id=87301b62"
import script from "./expensesDataTable.vue?vue&type=script&lang=js"
export * from "./expensesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports